import React, { forwardRef } from "react";
import { useConfiguration } from "../context/ConfigurationContext";

import Unknown from "../components/Errors/Unknown";
import { useFlipperQuery } from "../hooks/useFlipperQuery";

type WithFlipperProps = {
  testFlipper?: $TSFixMe;
  flipper: $TSFixMe;
  innerRef?: React.Ref<$TSFixMe>;
};

const withFlipper = <T extends WithFlipperProps = WithFlipperProps>(
  ChildComponent: React.ComponentType<T>,
) => {
  function WrappedComponent(props: Readonly<T>) {
    const { innerRef, testFlipper, ...restProps } = props;

    const configuration = useConfiguration();
    const { data, isError, isLoading } = useFlipperQuery({
      enabled: !testFlipper && !configuration.testFlipper,
    });
    const flipper = testFlipper ?? configuration.testFlipper ?? data;

    if (flipper) {
      return (
        <ChildComponent
          {...(restProps as T)}
          flipper={flipper}
          ref={innerRef}
        />
      );
    }
    if (isError) {
      return <Unknown {...restProps} />;
    }
    /* istanbul ignore else */
    if (isLoading) {
      return null;
    }
    /* istanbul ignore next */
    return null;
  }

  const ForwardRefWrappedComponent = forwardRef<
    $TSFixMe,
    Omit<T, "flipper" | "innerRef">
  >((props, ref) => <WrappedComponent {...(props as T)} innerRef={ref} />);

  ForwardRefWrappedComponent.displayName =
    ChildComponent.displayName ?? ChildComponent.name;
  return ForwardRefWrappedComponent;
};
export default withFlipper;
